<template>
  <div>
    <vs-checkbox class="mb-4"v-model="is_elastic" v-on:input="onChangeSearchType()">Switch to elastic search</vs-checkbox>
    <vx-card  v-can:any="['view-formulations', 'view-partial-formulation-details']" titleIcon="FilterIcon" ref="filterCard" :title="is_elastic ? 'Elastic Search' : 'Advanced Filters'" class="user-list-filters mb-8" :collapse-action="true">
      <div class="vx-row">
        <div class="vx-col md:w-1/6 sm:w-1/2 w-full hidden" v-if="!is_elastic">
          <label class="text-sm opacity-100 text-bold">Show all FGs where this is used</label>
          <vs-switch v-model="is_internal_search" icon-pack="feather" vs-icon-on="icon-check-circle"
                     vs-icon-off="icon-slash" class="mt-2 w-16">
            <span slot="on">Yes</span>
            <span slot="off">No</span>
          </vs-switch>
        </div>
        <div class="vx-col md:w-1/6 sm:w-1/2 w-full" v-if="!is_elastic">
          <label class="text-sm opacity-100 text-bold">Show only FGs with system M&F</label>
          <vs-switch v-model="filters['mf-missing']" icon-pack="feather" vs-icon-on="icon-check-circle"
                     vs-icon-off="icon-slash" class="mt-2 w-16">
            <span slot="on">Yes</span>
            <span slot="off">No</span>
          </vs-switch>
        </div>
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">General</label>
          <vs-input type="search"  placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full"/>
        </div>
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Applications</label>
          <v-select  :clearable="true" placeholder=""  v-model="filters['applications']"
                     :options="formulation_applications" :reduce="option => option.name" label="name"
                     :dir="$vs.rtl ? 'rtl' : 'ltr'" multiple></v-select>
        </div>
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full"  v-if="is_elastic">
          <label class="text-sm opacity-100 text-bold">Carriers</label>
          <v-select  :clearable="true" placeholder=""  v-model="filters['carriers']"
                     :options="formulation_carriers" :reduce="option => option.value" label="name"
                     :dir="$vs.rtl ? 'rtl' : 'ltr'" multiple></v-select>
        </div>
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Status</label>
          <v-select  :clearable="true" placeholder=""  v-model="filters['status']"
                     :options="['Development', 'Pre-Production', 'Production']"
                     :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
        </div>
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full" v-if="is_elastic">
          <label class="text-sm opacity-100 text-bold">QA Status</label>
          <v-select  :clearable="true" placeholder=""  v-model="filters['qa_status']"
                     :options="['Submitted to QA', 'Approved by QA', 'Not Submitted to QA', 'Rejected by QA']"
                     :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
        </div>
        <div class="vx-col md:w-1/6 sm:w-1/2 w-full" v-if="!is_elastic">
          <label class="text-sm opacity-100 text-bold">Include Archived</label>
          <vs-switch v-model="filters['include-archived']" icon-pack="feather" vs-icon-on="icon-check-circle"
                     vs-icon-off="icon-slash" class="mt-2 w-16">
            <span slot="on">Yes</span>
            <span slot="off">No</span>
          </vs-switch>
        </div>
      </div>
      <div class="vx-row mt-5">
        <div class="vx-col w-full ml-auto">
          <vs-button class="float-right mr-4" size="small"
                      color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
        </div>
      </div>
    </vx-card>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vx-card title="FORMULATION" v-can:any="['view-formulations', 'create-formulations', 'view-partial-formulation-details']">
        <template slot="actions">
          <div class="flex">
            <excel-download button_label="Export DEV to LIVE Coded products" :name="'dev-to-live-coded-formulation'" />
            <excel-download button_label="Export Formulations"  :name="'formulation-sheet'" :filters="filters" />
            <vs-button v-can="'create-formulations'" @click="onClickCreateFormulation" class="mr-4 mb-4" color="primary" type="filled">Create formulation</vs-button>
          </div>
        </template>
        <div slot="no-body" class="mt-4">

          <vs-table id="formulation-table" v-can:any="['view-formulations', 'view-partial-formulation-details']" :max-items="(meta.per_page) ? meta.per_page : 10" :data="formulations"  @sort="handleSort"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

            <template slot="thead">
              <vs-th width="10%" :sort-key="is_elastic ? 'code' : 'formulation-code'">FORMULATION CODE</vs-th>
              <vs-th width="10%" sort-key="name">NAME</vs-th>
<!--              <vs-th width="15%" >DESCRIPTION</vs-th>-->
              <!-- <vs-th width="5%" class="item-center">BATCH WEIGHT (KG)</vs-th> -->
              <vs-th width="10%">CARRIER</vs-th>
              <vs-th width="5%" class="item-center">PROJECT BRIEF</vs-th>
              <vs-th width="10%" sort-key="qa-status">QA STATUS</vs-th>
              <vs-th width="10%" class="" sort-key="status">STATUS</vs-th>
              <vs-th width="10%" class="" :sort-key="is_elastic ?  'type' : 'formulation_type'">TYPE</vs-th>
              <vs-th width="10%" class="">CUSTOMIZED M&F ADDED</vs-th>
              <vs-th width="5%">MAN PRICE PER KG (GBP)</vs-th>
              <vs-th width="5%">ITEMS COUNT</vs-th>
              <vs-th width="10%">ACTION</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr @click.native="onClickFormulationView(data[indextr].id)" style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">


                <vs-td :data="data[indextr].formulation_code">
                  <div class="flex items-center">
                    <a
                      :href="formulationLink(data[indextr].id)"
                      target="_blank"
                      @click.stop
                      class="text-primary"
                    >
                      {{ data[indextr].formulation_code || data[indextr].code }}
                    </a>
                    <vs-chip v-if="data[indextr].is_archived" style="font-size: x-small; border-radius: 0" transparent color="danger" class="ml-2">
                      Archived
                    </vs-chip>
                  </div>
                </vs-td>

                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>

<!--                <vs-td :data="data[indextr].description">-->
<!--                  {{data[indextr].description}}-->
<!--                </vs-td>-->

                <!-- <vs-td :data="data[indextr].batch_weight">
                  {{data[indextr].batch_weight}}
                </vs-td> -->

                <vs-td>
                  <!-- <span v-if="data[indextr].carrier"></span> -->
                  <span v-if="!is_elastic">
                    {{ displayCarrier(data[indextr].raw_material_items) }}
                  </span>
                  <span v-else>
                    <span v-for="(carrier, index) in data[indextr].carriers" :key="index">
                      {{ carrier.code }} <b v-if="data[indextr].carriers.length !== index +  1">,</b>
                    </span>
                  </span>
                </vs-td>

                <vs-td :data="data[indextr].customer_project_brief_id">
                  <vx-tooltip text="View project brief" position="left" v-if="!is_elastic">
                    <a v-if="data[indextr].customer_project_brief_id" @click.stop="onClickViewProjectBrief(data[indextr].customer_project_brief_id)">
                      {{data[indextr].project_brief}}
                    </a>
                  </vx-tooltip>
                  <span v-if="is_elastic">{{ data[indextr].project_brief_code || '-'}}</span>
                </vs-td>

                <vs-td :data="data[indextr].qa_status.name">
                  <vs-chip style="font-size: x-small; border-radius: 0" transparent v-bind:color="formulationQaColorFactory(data[indextr].qa_status.id)">
                    {{data[indextr].qa_status.name || data[indextr].qa_status }}
                  </vs-chip>
                </vs-td>

                <vs-td :data="data[indextr].status.name">
                  <vs-chip style="font-size: x-small; border-radius: 0" transparent :color="formulationsStatusColorFactory(data[indextr].status.id)">
                    {{data[indextr].status.name || data[indextr].status }}
                  </vs-chip>
                </vs-td>

                <vs-td :data="data[indextr].formulation_type">
                  {{data[indextr].formulation_type || data[indextr].type }}
                </vs-td>

                <vs-td :data="data[indextr].is_m_f_added" class="text-sm">
                  <b v-if="!is_elastic" :class="data[indextr].is_m_f_added ? 'text-primary' : 'text-danger'">
                    {{ data[indextr].is_m_f_added ? 'YES' : 'NO'}}
                  </b>
                  <b v-else :class="data[indextr].is_m_f_added === 'Yes' ? 'text-primary' : 'text-danger'">
                    {{ data[indextr].is_m_f_added}}
                  </b>
                </vs-td>

                <vs-td>
                  {{ data[indextr].cost || '-' }}
                </vs-td>

                <vs-td>
                  {{ data[indextr].items_count ||  data[indextr].item_count }}
                </vs-td>

                <vs-td>
                  <div class="vx-row">
                    <div class="vx-col md:w-1/5 w-full md:mb-0">
                      <vx-tooltip text="Open" position="left">
                        <vs-button @click.stop="onClickFormulationView(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                    </div>

<!--                    todo: need to implement permissions with dev or prod-->
                    <div class="vx-col md:w-1/5 w-full md:mb-0">
                      <vx-tooltip text="Copy a formulation" position="left">
                        <vs-button class="ml-1" @click.stop="onClickFormulationReplica(data[indextr].id)"
                                   size="small" color="dark" type="border" icon-pack="feather" icon="icon-copy"></vs-button>
                      </vx-tooltip>
                    </div>



<!--                    <vx-tooltip text="Create a dilution" position="top">-->
<!--                      <vs-button class="ml-4"-->
<!--                                 radius color="warning" type="border" icon-pack="feather" icon="icon-plus"></vs-button>-->
<!--                    </vx-tooltip>-->

                  </div>
                </vs-td>
              </vs-tr>
            </template>


          </vs-table>
          <vx-pagination
            v-can:any="['view-formulations', 'view-partial-formulation-details']"
            v-on:changeMaxItems="changePage"
            :size-array="meta.total ? meta.total : 20"
            :max-items="perPage"
            description-body="Rows per page"
            description-connector="of"
            description-title="Records"
            description
            :description-items="descriptionItems"
            :total="(meta.last_page)? meta.last_page : 0"
            v-model="page"  class="p-5"></vx-pagination>

        </div>
      </vx-card>
    </div>
  </div>
    <update-staff-pop-up ref="trackingImages"/>
    <create-formulation-pop-up ref="createFormulationPopUp"/>
    <replica-formulation-pop-up ref="replicaFormulationPopUp"/>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
import Utils from '@/mixins/Utils';
import UpdateStaffPopUp from '@/components/popups/staff/UpdateStaffPopUp'
import CreateFormulationPopUp from '@/components/popups/formulations/CreateFormulationPopUp'
import ReplicaFormulationPopUp from '@/components/popups/formulations/ReplicaFormulationPopUp'
import {defaultPagination, perPageList} from "@/constants/config";
import ErrorMessages from "@/mixins/ErrorMessages";
const StaffRepository = RepositoryFactory.get('staff')
const DepartmentsRepository = RepositoryFactory.get('departments')
const FormulationsRepository = RepositoryFactory.get('formulations')
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'AllUsersList',
  data () {
    return {
      selected: [],
      updateStaffSelected: [],
      options: ['Department 01', 'Department 02', 'Department 03', 'Department 04', 'Department 05', 'Department 06'],
      popupActive: false,
      createUserPopupActive: false,
      popUpTitle: '',
      editActive: false,
      edit: null,
      editProp: {},
      checkBox1: false,
      activeConfirm: false,
      staff: [],
      selectedStaff: {},
      createStaffForm: {},
      departments: [],
      users: [],
      filters: {},
      page : 1,
      total: 0,
      meta : {},
      sort : '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      is_internal_search: false,
      formulations: [],
      is_elastic: false
    }
  },
  components: {
    'v-select': vSelect,
    UpdateStaffPopUp,
    CreateFormulationPopUp,
    ReplicaFormulationPopUp
  },
  mixins : [Filter, Utils, ErrorMessages],
  async mounted () {
    this.$refs.filterCard.isContentCollapsed = false
    this.setFilterId('formulation_list_filters',['search','status','applications'])
    // this.$refs.filterCard.maxHeight = '1.5rem'
    // this.loadDepartments()
    await this.fetchFormulationApplications()
    await this.fetchFormulationCarriers()
    // await this.loadFormulations()
  },
  methods: {
    ...mapActions(['fetchFormulationApplications', 'fetchFormulationCarriers']),
    async refreshData () {
      this.loadFormulations()
    },

    async onClickFormulationView (id) {
      await this.$router.push({path: `/pages/formulations/${id}`})
    },
    formulationLink(id) {
      return this.$router.resolve({
        path: `/pages/formulations/${id}`
      }).href
    },
    async onClickFormulationReplica(id) {
      await this.$refs.replicaFormulationPopUp.openPopup(id)
    },
    async loadDepartments() {
      this.$vs.loading()
      const {data} = await DepartmentsRepository.get(' ', '', '', '' )
      this.departments =  data.data
      this.$vs.loading.close()
    },

    async loadFormulations() {
      this.$vs.loading({
        container: '#formulation-table',
        scale: 0.45
      })
      try {
        if(!this.is_elastic) {
          const {data} = await FormulationsRepository.get(this.page, this.filterQuery, this.perPage, this.sort)
          this.formulations =  data.data
          this.meta = data.meta
        } else {
          const {data} = await FormulationsRepository.getListWithElasticSearch(this.page, this.filterQuery, this.perPage, !this.filterQuery && !this.sort? `-created_at ` :  this.sort)
          this.formulations =  data.data
          this.meta = data.pagination
          await this.fetchFgPrices()
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#formulation-table > .con-vs-loading')
    },
    async fetchFgPrices() {
      try {
        const ids = []
        this.formulations.forEach((x) => {
          ids.push(x.id)
        })
        const { data} = (await FormulationsRepository.listOfFgPrices({ ids })).data
        this.formulations = this.formulations.map((x) => {
          const find = data.find((y) => y.id === x.id)
          x.cost = find.cost
          return x
        })
      } catch (error) {
        
      }
    },

    async onClickCreateFormulation () {
      await this.$refs.createFormulationPopUp.openPopup()
    },

    async onClickViewProjectBrief (id) {
      this.$router.push({path: `/pages/project-brief?open=${id}`})
    },

    openConfirm () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Remove Confirm',
        text: 'Are you sure you want to permanently remove this organization?',
        accept: this.acceptAlert
      })
    },

    acceptAlert () {
      this.$vs.notify({
        color: 'danger',
        title: 'Deleted Organization',
        position:'top-right',
        text: 'The selected organization was successfully deleted'
      })
    },

    filterQueryUpdate (){
      this.page = 1
      this.loadFormulations()
    },

    handleChangePage(page) {
      this.page=page;
      this.loadFormulations()
    },

    handleSort(key, active) {
      if(key){
        active = (active==='desc')? "-":'';
        this.sort=active+key;
        this.loadFormulations()
      }

    },
    changePage(index) {
      this.page = 1
      this.perPage = this.descriptionItems[index]
    },
    onChangeSearchType() {
      this.filters = {}
      this.sort= ''
    }

  },
  watch : {
    page(){
      this.loadFormulations()
    },
    perPage() {
      this.loadFormulations()
    },
    is_internal_search: function () {
      this.loadFormulations()
    }
  },
  computed: {
    ...mapGetters(['formulation_applications', 'formulation_carriers']),
    formulationQaColorFactory() {
      return id => {
        switch (id) {
          case 1:
            return '#a05a2a';
          case 2:
            return '#0090b5';
          case 3:
            return 'danger';
          case 4:
            return 'primary';
        }
      }

    },
    formulationsStatusColorFactory() {
      return id => {
        switch (id) {
          case 1:
            return 'warning';
          case 2:
            return '#00b578';
          case 3:
            return '#b52c00';
        }
      }
    }

  }
}
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
